import React, { useEffect, useState, Fragment } from 'react';
import { SparklesIcon, CheckIcon, VideoIcon, ChevronDownIcon, XIcon, CornerDownRightIcon } from 'lucide-react';
import { CountdownTimer } from '../components/CountdownTimer';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { UrgencyScarcity } from '../components/UrgencyScarcity';
const PURCHASE_LINK = 'https://f13dpf-q0.myshopify.com/cart/47511845830810:1?channel=buy_button';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/btVfW5Ztsf5z8ZFMXhozWf/Sin_titulo_(14_x_6_cm).png';
const RECRUITMENT_GUIDE_IMAGE = 'https://cdn.magicpatterns.com/uploads/ai5HZQKrQPdzo6UGXmiNag/Diseno_sin_titulo_(13).png';
const BONUS1_IMAGE = 'https://cdn.magicpatterns.com/uploads/hePzTgANxq5uEmiJv5jGxb/ChatGPT_Image_3_jul_2026,_01_00_30_a.m.png';
const BONUS2_IMAGE = 'https://cdn.magicpatterns.com/uploads/svm9HVj5a9NAXxDKtZvte8/ChatGPT_Image_3_jul_2026,_01_07_54_a.m.png';
const BONUS3_IMAGE = 'https://cdn.magicpatterns.com/uploads/wCdMLwq9KH2RUZ1z6fCvg7/ChatGPT_Image_3_jul_2026,_01_10_55_a.m.png';
const ELITE_PACK_LINK = 'https://f13dpf-q0.myshopify.com/cart/47516590014618:1?channel=buy_button';
function BuyButton({
  text,
  className = ''
}: {
  text: string;
  className?: string;
}) {
  return <a href={PURCHASE_LINK} target="_blank" rel="noopener noreferrer" className={`block w-full text-center bg-green-600 hover:bg-green-700 text-white font-black py-5 px-6 rounded-lg text-lg md:text-xl leading-tight transition-all duration-200 btn-pulse shadow-lg hover:shadow-xl hover:-translate-y-0.5 ${className}`} style={{
    fontFamily: 'Montserrat, sans-serif'
  }} data-id="element-56">
      {text}
    </a>;
}
// Devuelve un Date "desplazado" a la hora de Argentina (Buenos Aires),
// de modo que getDay()/getDate()/getMonth() reflejen el calendario argentino.
function getArgentinaNow(): Date {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Argentina/Buenos_Aires',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
  }).formatToParts(new Date());
  const get = (type: string) => parts.find(p => p.type === type)?.value ?? '0';
  return new Date(parseInt(get('year'), 10), parseInt(get('month'), 10) - 1, parseInt(get('day'), 10), parseInt(get('hour'), 10) % 24, parseInt(get('minute'), 10), parseInt(get('second'), 10));
}
function StarRating() {
  return <div className="flex gap-0.5 text-yellow-400 text-xl" data-id="element-57">{'⭐'.repeat(5)}</div>;
}
const FAQ_ITEMS: {
  question: string;
  answer: string;
}[] = [{
  question: '¿Funciona si tengo muy pocos seguidores?',
  answer: 'Sí. El algoritmo de Instagram y TikTok distribuye el contenido basado en relevancia y retención, no en número de seguidores. Cuentas de 200 seguidores han generado ventas reales aplicando estos principios. Lo que importa no es cuántos te siguen — es qué tan magnético es tu contenido.'
}, {
  question: '¿Tengo que saber editar video?',
  answer: 'No. El sistema está diseñado para grabarse y publicarse directamente desde el celular usando las herramientas nativas de Instagram Reels o TikTok. Sin CapCut avanzado. Sin Premiere. Sin nada que no sepas hacer ya.'
}, {
  question: '¿Funciona solo para la LumiSpa o para todos los productos Nu Skin?',
  answer: 'Para todos. El Método Formula UGC se adapta a cualquier producto, tecnología o suplemento: Galvánica Spa, ageLOC, Boost, TR90, Epoch. Hay estructuras y ganchos específicos para cada categoría de producto.'
}, {
  question: '¿La guía de reclutamiento es solo para emprendedoras nuevas?',
  answer: 'Funciona para cualquier nivel, pero está especialmente diseñada para quienes están construyendo su primera línea descendente y no saben cómo hablar del negocio en redes sin sonar a "es una pirámide".'
}, {
  question: '¿En cuánto tiempo veo los primeros resultados?',
  answer: 'Las primeras interacciones y DMs llegan en 24-72 horas después del primer Reel bien estructurado. Las primeras ventas orgánicas suelen ocurrir entre el día 3 y el día 14, dependiendo de tu constancia y tu audiencia actual.'
}, {
  question: '¿Qué pasa si lo compro y no funciona para mí?',
  answer: 'Tenés 7 días de garantía total. Sin preguntas. Sin condiciones. Sin formularios. Escribís un mensaje y te devuelvo el dinero completo. Así de simple.'
}];
function FaqAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="space-y-3" data-id="element-58">
      {FAQ_ITEMS.map((item, index) => {
      const isOpen = openIndex === index;
      return <div key={index} className={`rounded-2xl border overflow-hidden transition-all duration-300 ${isOpen ? 'border-[#85C3D7] bg-white shadow-[0_10px_30px_-12px_rgba(133,195,215,0.55)]' : 'border-gray-200 bg-white hover:border-[#98CBDD] shadow-sm'}`} data-id="element-59">
            <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="w-full flex items-center justify-between gap-4 text-left px-5 md:px-6 py-5" data-id="element-60">
              <span className={`font-black text-base md:text-lg leading-snug transition-colors duration-200 ${isOpen ? 'text-black' : 'text-gray-900'}`} style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-61">
                {item.question}
              </span>
              <span className={`flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center transition-all duration-300 ${isOpen ? 'bg-[#85C3D7] text-white rotate-180' : 'bg-gray-100 text-gray-500'}`} data-id="element-62">
                <ChevronDownIcon className="w-5 h-5" strokeWidth={2.5} data-id="element-63" />
              </span>
            </button>
            <div className={`grid transition-all duration-300 ease-in-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-64">
              <div className="overflow-hidden" data-id="element-65">
                <p className="px-5 md:px-6 pb-5 text-gray-600 text-sm md:text-[15px] leading-relaxed" data-id="element-66">
                  {item.answer}
                </p>
              </div>
            </div>
          </div>;
    })}
    </div>;
}
export function SalesPage() {
  // Re-renderiza cada minuto para que el día cambie automáticamente al pasar
  // la medianoche (00:00 hs) según el calendario de Argentina.
  const [, setTick] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => setTick(t => t + 1), 60 * 1000);
    return () => clearInterval(interval);
  }, []);
  const days = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  const months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  const today = getArgentinaNow();
  const dateTextUpper = `HOY ${days[today.getDay()].toUpperCase()} ${today.getDate()} DE ${months[today.getMonth()].toUpperCase()}`;
  return <div className="w-full bg-white" style={{
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-67">
      {/* STICKY URGENCY BAR */}
      <div className="sticky top-0 z-40 text-white py-3 px-4 text-center bg-[#85C3D7]" data-id="element-68">
        <div className="flex flex-wrap items-center justify-center gap-2 text-sm md:text-base font-bold" style={{
        fontFamily: 'Montserrat, sans-serif'
      }} data-id="element-69">
          <span data-id="element-70">⏳ OFERTA EXPIRA EN:</span>
          <CountdownTimer data-id="element-71" />
          <span data-id="element-72">|</span>
          <span data-id="element-73">🔥 SOLO QUEDAN 3 CUPOS {dateTextUpper} 🔥</span>
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div className="max-w-3xl mx-auto px-4 py-0" data-id="element-74">
        {/* HERO SECTION */}
        <section className="py-10 text-center pt-[10px] pb-[10px]" data-id="element-75">
          {/* Tag */}
          <div className="inline-block text-white text-sm font-bold px-4 py-2 rounded-full mb-5 tracking-wide bg-[#000000] pt-[8px] pb-[8px] pl-[16px] pr-[16px]" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-76">
            📌 Para Emprendedoras NuSkin✨
          </div>

          {/* Main Headline */}
          <h1 className="md:text-5xl font-black text-black mb-4 uppercase text-center text-[30px] pt-[10px] pb-[10px]" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-77">
            Dejá de perseguir clientas.
            <br data-id="element-78" />
            Hacé que{' '}
            <span className="text-[#98CBDD] underline decoration-[#98CBDD]" data-id="element-79">
              ELLAS te PERSIGAN
            </span>{' '}
            a vos.
          </h1>

          {/* Product Image */}
          <a href={PURCHASE_LINK} target="_blank" rel="noopener noreferrer" className="block mb-6 cursor-pointer" data-id="element-80">
            <img src="https://cdn.magicpatterns.com/uploads/eKTZAz1TcMYdMzRsh1bFbT/ChatGPT_Image_2_jul_2026,_09_55_38_p.m..png" alt="Megapack Fórmula UGC para Emprendedoras Nu Skin" className="w-full max-w-sm mx-auto rounded-2xl shadow-2xl hover:scale-105 transition-transform duration-300" data-id="element-81" />
          </a>

          {/* Subheadline */}
          <p className="md:text-2xl text-gray-800 mb-6 font-[700] text-[18px]" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-82">
            👉🏻{' '}
            <span className="underline decoration-[#98CBDD] decoration-4 underline-offset-2" data-id="element-83">
              Tu primera venta en menos de 7 días
            </span>{' '}
            con tu negocio de NuSkin, aunque no tengas experiencia, ni
            seguidores.
          </p>

          {/* Description */}
          <p className="text-base md:text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-84">
            Aplica el método <strong data-id="element-85">FÓRMULA UGC</strong> para que tu contenido{' '}
            <strong data-id="element-86">SI VENDA</strong> por vos <strong data-id="element-87">TODOS LOS DÍAS</strong>,
            usando solo tu celular y tu rutina real.
          </p>

          {/* Negative list */}
          <div className="border-l-4 border-red-500 rounded-lg p-5 mb-8 text-left space-y-3 bg-[#FFDDDD]" data-id="element-88">
            <p className="flex items-start gap-2 text-gray-800 font-medium" data-id="element-89">
              ❌ <span data-id="element-90">Sin tener que enviar DMs en frío</span>
            </p>
            <p className="flex items-start gap-2 text-gray-800 font-medium" data-id="element-91">
              ❌{' '}
              <span data-id="element-92">
                Sin tener que iniciar conversaciones incómodas en la fila del
                súper
              </span>
            </p>
            <p className="flex items-start gap-2 text-gray-800 font-medium" data-id="element-93">
              ❌ <span data-id="element-94">Sin depender de familiares o amigos</span>
            </p>
            <p className="flex items-start gap-2 text-gray-800 font-medium" data-id="element-95">
              ❌{' '}
              <span data-id="element-96">
                Sin publicar "placas / fotos catálogo" que{' '}
                <strong data-id="element-97">NO VENDEN.</strong>
              </span>
            </p>
          </div>

          {/* CTA Button */}
          <BuyButton text="👉 SÍ, QUIERO DEJAR DE PERSEGUIR Y ATRAER — ACCESO INMEDIATO" data-id="element-98" />
          <p className="text-sm text-gray-500 mt-3 font-medium" data-id="element-99">
            ✅ Acceso inmediato · Un solo pago · Garantía 7 días · +500
            Emprendedoras ⭐⭐⭐⭐⭐
          </p>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-100" />

        {/* PAIN SECTION */}
        <section className="py-12 px-4 bg-gray-50" data-id="element-101">
          <div className="max-w-5xl mx-auto rounded-[32px] p-8 md:p-12 shadow-[0_8px_30px_rgb(0,0,0,0.08)] border border-gray-100 bg-[#FFDDDD]" data-id="element-102">
            <h2 className="text-3xl md:text-4xl font-black text-center mb-10 text-[#1A1D29]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-103">
              ¿TE IDENTIFICAS?
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10" data-id="element-104">
              {[<Fragment data-id="element-105">
                  Sentís que tenes{' '}
                  <strong data-id="element-106">LOS MEJORES PRODUCTOS DE BELLEZA DEL MERCADO</strong>,
                  pero aún así, las clientas{' '}
                  <strong className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-107">
                    ¿NO TE LO COMPRAN?
                  </strong>
                </Fragment>, <Fragment data-id="element-108">
                  Sentís que las{' '}
                  <strong className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-109">
                    PERSEGUIS TODO EL TIEMPO
                  </strong>{' '}
                  ¿cuando debería de ser al revés?
                </Fragment>, <Fragment data-id="element-110">
                  Ganas{' '}
                  <strong className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-111">
                    MENOS DE $3.000 USD AL MES
                  </strong>{' '}
                  y querés que este negocio te funcione.
                </Fragment>, <Fragment data-id="element-112">
                  Invertiste en las tecnologías, y aún{' '}
                  <strong className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-113">
                    NO LOGRASTE RECUPERAR TU INVERSIÓN
                  </strong>
                  .
                </Fragment>, <Fragment data-id="element-114">
                  Logras vender algo pero{' '}
                  <strong className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-115">
                    NO ES DE FORMA CONSTANTE Y PREDECIBLE
                  </strong>{' '}
                  cada mes.
                </Fragment>, <Fragment data-id="element-116">
                  Publicas fotos, mandas difusiones de Whatsapp o mensajes por
                  DM y{' '}
                  <strong className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-117">
                    TE CLAVAN EL VISTO
                  </strong>
                  .
                </Fragment>, <Fragment data-id="element-118">
                  Te piden precio y te dicen que lo "tienen que pensar" o peor
                  aún:{' '}
                  <strong className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-119">
                    DESAPARECEN
                  </strong>
                  .
                </Fragment>, <Fragment data-id="element-120">
                  Te frustra{' '}
                  <strong className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-121">
                    NO GENERAR DINERO
                  </strong>{' '}
                  como esperabas.
                </Fragment>, <Fragment data-id="element-122">
                  Tenes miedo de estar{' '}
                  <strong className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-123">
                    PERDIENDO EL TIEMPO
                  </strong>
                  .
                </Fragment>, <Fragment data-id="element-124">
                  <strong className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-125">DUDAS</strong>{' '}
                  si este negocio es para vos.
                </Fragment>, <Fragment data-id="element-126">
                  Querés lograr el próximo rango de la empresa pero{' '}
                  <strong className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-127">
                    ESTÁS ESTANCADA
                  </strong>
                  .
                </Fragment>].map((content, i) => <div key={i} className="flex items-start gap-3" data-id="element-128">
                  <span className="text-xl flex-shrink-0 mt-0.5" data-id="element-129">💔</span>
                  <p className="text-gray-700 text-base md:text-lg font-medium leading-relaxed" data-id="element-130">
                    {content}
                  </p>
                </div>)}
            </div>

            <div className="border-l-4 border-gray-300 pl-5 py-2 max-w-3xl mx-auto" data-id="element-131">
              <p className="text-gray-600 text-base md:text-lg italic leading-relaxed" data-id="element-132">
                Y lo peor: ves a otras líderes creciendo, vendiendo cada mes y{' '}
                <strong className="text-gray-800" data-id="element-133">NO ENTENDES CÓMO</strong>... o
                por qué a ellas les funciona y a vos no.
              </p>
            </div>
          </div>

          <div className="mt-10 text-center max-w-2xl mx-auto" data-id="element-134">
            <p className="text-lg md:text-xl text-gray-700 italic mb-2" data-id="element-135">
              Déjame decirte que te entiendo, yo también pasé por ahí.
            </p>
            <p className="text-xl md:text-2xl font-bold italic text-gray-800 mb-8" data-id="element-136">
              Pero la buena noticia es que tiene solución 🩵
            </p>

            <div className="bg-[#98CBDD] text-white rounded-2xl p-6 md:p-8 shadow-md" data-id="element-137">
              <p className="text-2xl md:text-3xl font-black" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-138">
                El problema NO son los productos, ni el precio. Es LA
                ESTRATEGIA.
              </p>
            </div>
          </div>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-139" />
      </div>

      {/* TRUTH SECTION - Full width black */}
      <section className="text-white py-12 px-4 bg-[#000000]" data-id="element-140">
        <div className="max-w-3xl mx-auto" data-id="element-141">
          <div className="text-center mb-4" data-id="element-142">
            <span className="inline-block text-white text-xs md:text-sm font-bold px-4 py-2 rounded-full uppercase tracking-widest bg-[#FD3A6B]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-143">
              EL PROBLEMA
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl font-black text-center mb-8 leading-tight" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-144">
            La verdad que nadie en tu línea ascendente
            <br data-id="element-145" />
            <span className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-146">
              te está diciendo:
            </span>
          </h2>

          <div className="space-y-4 text-base md:text-lg text-gray-200 leading-relaxed" data-id="element-147">
            <p data-id="element-148">
              El modelo de{' '}
              <strong className="text-white" data-id="element-149">
                "hace una lista de 100 personas y contactalos uno por uno"
              </strong>{' '}
              fue diseñado en los años 80.
            </p>
            <p data-id="element-150"></p>
            <p className="text-xl font-bold text-white text-center py-4" data-id="element-151">
              Hoy, la clienta que te va a comprar{' '}
              <span className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-152">
                NO quiere que la busques.
              </span>
              <br data-id="element-153" />
              Quiere encontrarte{' '}
              <span className="font-[800] text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-154">
                ELLA sola.
              </span>
            </p>
            <p className="text-[20px] font-[800] text-[#FFFFFF] bg-[#10B981]" data-id="element-155">
              Y te encuentra EN INSTAGRAM si haces un buen CONTENIDO UGC.
            </p>
          </div>

          <div className="text-black rounded-xl p-6 my-8 text-center bg-[#FFFFFF]" data-id="element-156">
            <p className="text-base md:text-lg font-bold leading-relaxed bg-[#FFFFFF]" data-id="element-157">
              El UGC cambió la forma de consumir de las clientas. Y SI NO LO
              DOMINÁS, NO TENÉS VENTAS. Así de simple.
            </p>
          </div>

          <div className="space-y-3 text-base md:text-lg text-gray-200" data-id="element-158">
            <p className="text-center text-[20px] font-[800] text-[#FFFFFF]" data-id="element-159">
              Pero <strong className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-160">OJO.</strong>{' '}
              NO es simplemente grabarte usando el producto. Eso lo hace
              cualquiera. ❌
            </p>
            <p className="text-center font-bold text-xl text-[#FFFFFF] bg-[#000000]" data-id="element-161">
              Se trata de una{' '}
              <span className="font-[800] text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-162">
                ESTRUCTURA de videos que SI CONVIERTEN
              </span>{' '}
              en ventas.
            </p>
          </div>
        </div>
      </section>

      <div className="max-w-3xl mx-auto px-4" data-id="element-163">
        {/* PRODUCT INTRO */}
        <section className="py-10 text-center" data-id="element-164">
          <div className="text-center mb-4" data-id="element-165">
            <span className="inline-block text-xs md:text-sm font-bold px-4 py-2 rounded-full uppercase tracking-widest text-[#FFFFFF] bg-[#D7B2D8] pl-[16px] pr-[16px]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-166">
              LA SOLUCIÓN
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-black mb-4 leading-tight" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-167">
            ✨ Fórmula UGC para
            <br data-id="element-168" />
            Emprendedoras Nu Skin ✨
          </h2>

          <div className="flex justify-center mb-6" data-id="element-169">
            <img src="https://cdn.magicpatterns.com/uploads/6S5k6MsQnxyBY3GvsZzzuj/ChatGPT_Image_3_jul_2026,_12_48_57_a.m.png" alt="Fórmula UGC para Emprendedoras Nu Skin" className="w-full max-w-md rounded-2xl shadow-xl" data-id="element-170" />
          </div>

          <p className="text-lg md:text-xl font-bold text-gray-700 mb-8" data-id="element-171">
            Un sistema <strong data-id="element-172">COMPLETO</strong> para que{' '}
            <strong data-id="element-173">TRANSFORMES</strong> tu forma de trabajar y tus ventas esta
            misma semana.
          </p>

          <div className="border border-gray-200 rounded-[32px] p-6 md:p-10 shadow-[0_8px_30px_rgb(0,0,0,0.08)] mb-8 bg-[#EBFFF3]" data-id="element-174">
            <h3 className="text-2xl font-black text-black mb-6 text-center bg-[#EBFFF3]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-175">
              ¿QUÉ VAS A LOGRAR CON ESTE PROGRAMA?
            </h3>

            <div className="space-y-3 text-left mb-8" data-id="element-176">
              <p className="flex items-start gap-2 text-base md:text-lg text-gray-800 font-medium" data-id="element-177">
                ✅{' '}
                <span data-id="element-178">
                  <strong className="text-[#FFFFFF] bg-[#10B981]" data-id="element-179">
                    DEJAR de PERSEGUIR
                  </strong>{' '}
                  clientas y que en cambio{' '}
                  <strong className="text-[#FFFFFF] bg-[#10B981]" data-id="element-180">
                    ELLAS te PERSIGAN a VOS.
                  </strong>
                </span>
              </p>
              <p className="flex items-start gap-2 text-base md:text-lg text-gray-800 font-medium" data-id="element-181">
                ✅{' '}
                <span data-id="element-182">
                  Te tomen de{' '}
                  <strong className="text-[#000000] bg-[#EBFFF3]" data-id="element-183">
                    REFERENTE
                  </strong>{' '}
                  en el mercado y{' '}
                  <strong className="text-[#000000] bg-[#EBFFF3]" data-id="element-184">
                    CONFÍEN
                  </strong>{' '}
                  en vos.
                </span>
              </p>
              <p className="flex items-start gap-2 text-base md:text-lg text-gray-800 font-medium" data-id="element-185">
                ✅{' '}
                <span data-id="element-186">
                  Te pidan info para{' '}
                  <strong className="text-[#000000] bg-[#EBFFF3]" data-id="element-187">
                    COMPRAR REALMENTE
                  </strong>{' '}
                  y NO por curiosidad.
                </span>
              </p>
              <p className="flex items-start gap-2 text-base md:text-lg text-gray-800 font-medium" data-id="element-188">
                ✅{' '}
                <span className="bg-[#EBFFF3]" data-id="element-189">
                  Tengas nuevas{' '}
                  <strong className="text-[#000000] bg-[#EBFFF3]" data-id="element-190">
                    CLIENTAS
                  </strong>{' '}
                  que{' '}
                  <strong className="text-[#000000] bg-[#EBFFF3]" data-id="element-191">
                    CONSUMEN PRODUCTOS TODOS LOS MESES
                  </strong>
                </span>
              </p>
              <p className="flex items-start gap-2 text-base md:text-lg text-gray-800 font-medium" data-id="element-192">
                ✅{' '}
                <span data-id="element-193">
                  Tengas nuevas <strong data-id="element-194">SOCIAS</strong> que{' '}
                  <strong data-id="element-195">TRABAJEN EN TU EQUIPO</strong>
                </span>
              </p>
              <p className="flex items-start gap-2 text-base md:text-lg text-gray-800 font-medium" data-id="element-196">
                ✅{' '}
                <span data-id="element-197">
                  Logres llegar al próximo{' '}
                  <strong className="text-[#FFFFFF] bg-[#10B981]" data-id="element-198">
                    RANGO DE LA COMPAÑÍA
                  </strong>
                </span>
              </p>
            </div>

            <p className="text-base text-gray-700 mb-4 font-[400]" data-id="element-199">
              Esto es exactamente lo que realmente me ayudó a despegar mi
              negocio:
            </p>

            <div className="text-white rounded-xl p-6 mb-6 bg-[#ECD7EB]" data-id="element-200">
              <p className="text-xl font-black mb-2 text-[#000000]" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-201">
                🔥 Método FÓRMULA UGC
              </p>
              <p className="font-bold text-lg text-[#000000]" data-id="element-202">
                (Rutina → Problema → Solución)
              </p>
            </div>

            <div className="border border-gray-200 rounded-xl p-5 text-left mb-6 bg-[#FFFFFF]" data-id="element-203">
              <p className="text-base text-gray-800 leading-relaxed" data-id="element-204">
                <strong data-id="element-205">UGC estratégico</strong> = lograr que la persona piense:
                <br data-id="element-206" />
                <br data-id="element-207" />
                <span className="text-green-600 font-bold" data-id="element-208">
                  "ella es como yo"
                </span>{' '}
                →{' '}
                <span className="text-green-600 font-bold" data-id="element-209">"eso me pasa"</span>{' '}
                →{' '}
                <span className="text-green-600 font-bold" data-id="element-210">
                  "lo necesito" → "lo quiero."
                </span>
                .
                <br data-id="element-211" />
                <br data-id="element-212" />
                Resultado: antes de que vos respondas DM… las clientas{' '}
                <strong className="text-[#FFFFFF] bg-[#10B981]" data-id="element-213">
                  YA están decididas, te escriben Y TE COMPRAN a vos
                </strong>{' '}
                💸
              </p>
            </div>

            {/* Mid-page CTA */}
            <BuyButton text="🚀 QUIERO ACCEDER A LA FÓRMULA UGC AHORA" data-id="element-214" />
            <p className="text-sm text-gray-500 mt-3" data-id="element-215">
              ✅ Acceso inmediato · Un solo pago · Garantía 7 días · +500
              Emprendedoras ⭐⭐⭐⭐⭐
            </p>
          </div>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-216" />

        {/* WHAT'S INCLUDED */}
        <section className="py-10" data-id="element-217">
          <h2 className="text-2xl md:text-3xl font-black text-black text-center mb-8 uppercase" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-218">
            ¿Qué incluye exactamente?
          </h2>

          <div className="flex justify-center mb-8" data-id="element-219">
            <img src="https://cdn.magicpatterns.com/uploads/cBa9qzbkfwLJk47oktobBJ/Diseno_sin_titulo_(21).png" alt="Qué incluye exactamente" className="w-full max-w-md rounded-2xl shadow-xl" data-id="element-220" />
          </div>

          <div className="space-y-4" data-id="element-221">
            <div className="border-2 border-black rounded-xl p-5 flex gap-4 items-start bg-[#ECD7EB]" data-id="element-222">
              <div className="bg-black text-white font-black text-lg w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-223">
                1
              </div>
              <div data-id="element-224">
                <p className="font-black text-black text-base" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-225">
                  Módulo 1
                </p>
                <p className="text-gray-700 text-sm" data-id="element-226">
                  Bases y fundamentos del UGC (Contenido Generado por el
                  Usuario)
                </p>
              </div>
            </div>
            <div className="border-2 border-black rounded-xl p-5 flex gap-4 items-start bg-[#ECD7EB]" data-id="element-227">
              <div className="bg-black font-black text-lg w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 text-[#FFFFFF]" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-228">
                2
              </div>
              <div data-id="element-229">
                <p className="font-black text-black text-base" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-230">
                  Módulo 2
                </p>
                <p className="text-gray-700 text-sm" data-id="element-231">
                  Estructura de videos que SI VENDEN
                </p>
              </div>
            </div>
            <div className="border-2 border-black rounded-xl p-5 flex gap-4 items-start bg-[#ECD7EB]" data-id="element-232">
              <div className="bg-black text-white font-black text-lg w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-233">
                3
              </div>
              <div data-id="element-234">
                <p className="font-black text-black text-base" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-235">
                  Módulo 3
                </p>
                <p className="text-gray-700 text-sm" data-id="element-236">
                  El Arte de Cómo vender SIN VENDER
                </p>
              </div>
            </div>
            <div className="border-2 border-black rounded-xl p-5 flex gap-4 items-start bg-[#ECD7EB]" data-id="element-237">
              <div className="bg-black text-white font-black text-lg w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-238">
                4
              </div>
              <div data-id="element-239">
                <p className="font-black text-black text-base" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-240">
                  Módulo 4
                </p>
                <p className="text-gray-700 text-sm" data-id="element-241">
                  Ganchos Magnéticos que facturan
                </p>
              </div>
            </div>
            <div className="border-2 border-black rounded-xl p-5 flex gap-4 items-start bg-[#ECD7EB]" data-id="element-242">
              <div className="bg-black text-white font-black text-lg w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-243">
                5
              </div>
              <div data-id="element-244">
                <p className="font-black text-black text-base" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-245">
                  Módulo 5
                </p>
                <p className="text-gray-700 text-sm" data-id="element-246">
                  El Cierre Invisible (Protocolo 24/48/72hs)
                </p>
              </div>
            </div>
            <div className="border-2 border-black rounded-xl p-5 flex gap-4 items-start bg-[#ECD7EB]" data-id="element-247">
              <div className="bg-black text-white font-black text-lg w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-248">
                6
              </div>
              <div data-id="element-249">
                <p className="font-black text-black text-base" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-250">
                  Módulo 6
                </p>
                <p className="text-gray-700 text-sm" data-id="element-251">
                  Mentalidad de Creadora Millonaria
                </p>
              </div>
            </div>
            <div className="border-2 border-green-600 rounded-xl p-5 flex gap-4 items-start bg-[#F0FDF4]" data-id="element-252">
              <div className="bg-green-600 text-white font-black text-lg w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-253">
                7
              </div>
              <div data-id="element-254">
                <p className="font-black text-black text-base" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-255">
                  Módulo 7
                </p>
                <p className="text-gray-700 text-sm" data-id="element-256">
                  Tu próximo Nivel - De cero o pocas ventas a Vendo todas las
                  semanas
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-257" />

        {/* FOR YOU / NOT FOR YOU */}
        <section className="py-10" data-id="element-258">
          <h2 className="text-2xl md:text-3xl font-black text-black text-center mb-8 uppercase" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-259">
            ¿PARA QUIÉN ES ESTE PROGRAMA?
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-260">
            <div className="bg-green-50 border-2 border-green-600 rounded-xl p-6" data-id="element-261">
              <h3 className="text-xl font-black text-green-700 mb-4 text-center" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-262">
                ✅ Esto es PARA vos si:
              </h3>
              <div className="space-y-3 text-sm text-gray-800" data-id="element-263">
                <p data-id="element-264">
                  ✅ Acabas de iniciar o llevas meses en NuSkin y tus ventas NO
                  llegan como esperabas
                </p>
                <p data-id="element-265">
                  ✅ No sabes qué publicar en Instagram y sólo usas las fotos
                  oficiales de la empresa
                </p>
                <p data-id="element-266">
                  ✅ Alguien te preguntó el precio, desapareció y no supiste qué
                  hacer
                </p>
                <p data-id="element-267">
                  ✅ Querés que tu perfil atraiga clientas y socias sin que
                  tengas que perseguirlas a diario
                </p>
                <p data-id="element-268">
                  ✅ Tenés menos de 60-90 minutos al día para crear contenido y
                  querés maximizar tu tiempo
                </p>
                <p data-id="element-269">
                  ✅ Ya vendés pero querés aumentar tu facturación y subir de
                  rango
                </p>
              </div>
            </div>
            <div className="bg-gray-50 border-2 border-gray-300 rounded-xl p-6" data-id="element-270">
              <h3 className="text-xl font-black text-gray-700 mb-4 text-center" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-271">
                ❌ Esto NO es para vos si:
              </h3>
              <div className="space-y-3 text-sm text-gray-800" data-id="element-272">
                <p data-id="element-273">
                  ❌ Buscas hacerte rica de la noche a la mañana sin trabajar ni
                  aprender nuevas estrategias de venta (UGC)
                </p>
                <p data-id="element-274">❌ No estás dispuesta a mostrar ni tus manos en cámara</p>
                <p data-id="element-275">
                  ❌ Querés seguir usando el método de "amplia tu lista y
                  escríbele a tus 100 contactos"
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-276" />

        {/* BEFORE / AFTER */}
        <section className="py-10" data-id="element-277">
          <h2 className="text-2xl md:text-3xl font-black text-black text-center mb-8 uppercase" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-278">
            ANTES vs DESPUÉS
            <br data-id="element-279" />
            <span className="text-[#10B981]" data-id="element-280">(con Fórmula UGC)</span>
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-281">
            <div className="bg-red-50 border-2 border-red-400 rounded-xl p-6" data-id="element-282">
              <h3 className="text-lg font-black text-red-600 mb-4 text-center" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-283">
                😩 ANTES de Fórmula UGC
              </h3>
              <div className="space-y-3 text-sm text-gray-800" data-id="element-284">
                <p data-id="element-285">
                  ❌ Te drenabas contactando en frío y persiguiendo clientas que
                  no compran
                </p>
                <p data-id="element-286">❌ Improvisabas contenido y terminabas agotada</p>
                <p data-id="element-287">❌ No lograbas cerrar nuevas ventas todas las semanas</p>
              </div>
            </div>
            <div className="bg-green-50 border-2 border-green-500 rounded-xl p-6" data-id="element-288">
              <h3 className="text-lg font-black text-green-700 mb-4 text-center" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-289">
                😍 DESPUÉS de Fórmula UGC
              </h3>
              <div className="space-y-3 text-sm text-gray-800" data-id="element-290">
                <p data-id="element-291">✅ No perseguís más clientas, las atraés </p>
                <p data-id="element-292">✅ Tenés una estructura de contenido que SI VENDE</p>
                <p data-id="element-293">✅ Lográs cerrar nuevas ventas TODAS las semanas </p>
                <p data-id="element-294">✅ Tenés tiempo y energía para tu familia y otras tareas</p>
              </div>
            </div>
          </div>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-295" />

        {/* TESTIMONIALS */}
        <section className="py-10" data-id="element-296">
          <h2 className="text-2xl md:text-3xl font-black text-black text-center mb-8 uppercase" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-297">
            Testimonios de emprendedoras que ya
            <br data-id="element-298" />
            <span className="text-[#10B981]" data-id="element-299">aplicaron Fórmula UGC:</span>
          </h2>

          <div className="space-y-5" data-id="element-300">
            <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-md" data-id="element-301">
              <StarRating data-id="element-302" />
              <p className="text-gray-800 text-sm md:text-base italic mt-3 leading-relaxed" data-id="element-303">
                "Llevaba 8 meses en Nu Skin sin superar las 3 ventas al mes.
                Apliqué el Método de Fórmula UGC en mis Reels y en la segunda
                semana tuve 7 personas escribiéndome sin yo haberles escrito
                primero. Cerré 5 ventas en un sólo fin de semana, estoy
                feliiiiz!!"
              </p>
              <p className="text-gray-600 text-sm font-bold mt-3" data-id="element-304">
                — Valentina R. Córdoba, Argentina.
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-md" data-id="element-305">
              <StarRating data-id="element-306" />
              <p className="text-gray-800 text-sm md:text-base italic mt-3 leading-relaxed" data-id="element-307">
                "Lo que más me cambió fue aprender a NO responder el precio
                directamente cuando me preguntan. Ese solo cambio de
                "informante" a "vender y ayudar al cliente" me permitió lograr
                cerrar 1 venta nueva en 5 días."
              </p>
              <p className="text-gray-600 text-sm font-bold mt-3" data-id="element-308">
                — Mariana T. Mendoza, Argentina.
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-md" data-id="element-309">
              <StarRating data-id="element-310" />
              <p className="text-gray-800 text-sm md:text-base italic mt-3 leading-relaxed" data-id="element-311">
                "Tenía pánico de hablar a cámara. Con el programa me di cuenta
                de que mi baño era todo lo que necesitaba. Mi primer Video UGC
                llegó a 4,200 reproducciones y me trajo 5 consultas, 1
                compró!!!. Nunca había me pasado!! Gracias Bren!."
              </p>
              <p className="text-gray-600 text-sm font-bold mt-3" data-id="element-312">
                — Andrea L. Tucumán, Argentina.
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-md" data-id="element-313">
              <StarRating data-id="element-314" />
              <p className="text-gray-800 text-sm md:text-base italic mt-3 leading-relaxed" data-id="element-315">
                "El script de DM para cuando preguntan el precio lo copié
                textual. Funcionó la primera vez que lo usé. La chica terminó
                comprando el kit completo, luego de seguir los pasos y no solo
                la LumiSpa."
              </p>
              <p className="text-gray-600 text-sm font-bold mt-3" data-id="element-316">
                — Camila P. CABA, Argentina.
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-md" data-id="element-317">
              <StarRating data-id="element-318" />
              <p className="text-gray-800 text-sm md:text-base italic mt-3 leading-relaxed" data-id="element-319">
                "Agregué la Guía de Reclutamiento y Vende por Historias, y en 3
                semanas tuve 2 socias nuevas que llegaron solas después de ver
                mis Stories de negocio. Nunca las busqué. Ellas me escribieron
                primero y las cerré. Graciass!"
              </p>
              <p className="text-gray-600 text-sm font-bold mt-3" data-id="element-320">
                — Sofía M. Tierra del Fuego, Argentina.
              </p>
            </div>
          </div>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-321" />

        {/* BONUSES SECTION */}
        <section className="py-10" id="compra" data-id="element-322">
          <div className="text-center mb-8" data-id="element-323">
            <span className="text-white font-black text-sm px-4 py-2 rounded-full uppercase tracking-wide bg-[#10B981]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-324">
              🎁 6 BONOS — SOLO POR HOY
            </span>
          </div>

          <h2 className="text-2xl md:text-3xl font-black text-black text-center mb-10 uppercase" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-325">
            🎁 Bonos de REGALO incluidos HOY
          </h2>

          {/* Bonus 1 */}
          <div className="mb-10 text-center" data-id="element-326">
            <div className="inline-block font-black text-sm px-4 py-2 rounded-full mb-4 uppercase tracking-wide text-[#FFFFFF] bg-[#10B981]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-327">
              🎁 Bono #1
            </div>
            <h3 className="text-xl font-black text-black mb-2" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-328">
              El Script Perfecto de DM
            </h3>
            <p className="text-green-600 font-bold mb-4" data-id="element-329">
              De "Hola, info" a "Ya pagué"
            </p>
            <a href={PURCHASE_LINK} target="_blank" rel="noopener noreferrer" className="block cursor-pointer" data-id="element-330">
              <img src={BONUS1_IMAGE} alt="Bono #1 - Script Perfecto de DM" className="w-full max-w-sm mx-auto rounded-xl shadow-lg hover:scale-105 transition-transform duration-300" style={{
              width: '400px',
              height: '400px',
              objectFit: 'contain'
            }} data-id="element-331" />
            </a>
            <p className="text-gray-700 text-sm mt-4 max-w-md mx-auto" data-id="element-332">
              La secuencia de mensajes para convertir curiosidad en compra SIN
              sonar desesperada: qué decir, cuándo preguntar, cómo guiar, y cómo
              cerrar con seguridad.
            </p>
          </div>

          {/* Bonus 2 */}
          <div className="mb-10 text-center" data-id="element-333">
            <div className="inline-block font-black text-sm px-4 py-2 rounded-full mb-4 uppercase tracking-wide text-[#FFFFFF] bg-[#10B981]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-334">
              🎁 Bono #2
            </div>
            <h3 className="text-xl font-black text-black mb-2" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-335">
              Banco de Plantillas, Ideas y Recursos Listos para usar
            </h3>
            <a href={PURCHASE_LINK} target="_blank" rel="noopener noreferrer" className="block cursor-pointer" data-id="element-336">
              <img src={BONUS2_IMAGE} alt="Bono #2 - Banco de Plantillas" className="w-full max-w-sm mx-auto rounded-xl shadow-lg hover:scale-105 transition-transform duration-300" style={{
              width: '400px',
              height: '400px',
              objectFit: 'contain'
            }} data-id="element-337" />
            </a>
            <p className="text-gray-700 text-sm mt-4 max-w-md mx-auto" data-id="element-338">
              Para que no empieces nunca más desde cero: plantillas y recursos
              para crear contenido UGC más rápido, con estructura, y con
              claridad de qué mostrar y cómo mostrarlo.
            </p>
          </div>

          {/* Bonus 3 */}
          <div className="mb-10 text-center" data-id="element-339">
            <div className="inline-block font-black text-sm px-4 py-2 rounded-full mb-4 uppercase tracking-wide text-[#FFFFFF] bg-[#10B981]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-340">
              🎁 Bono #3
            </div>
            <h3 className="text-xl font-black text-black mb-2" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-341">
              Calendario de Contenido que te ahorra HORAS de tu tiempo
            </h3>
            <a href={PURCHASE_LINK} target="_blank" rel="noopener noreferrer" className="block cursor-pointer" data-id="element-342">
              <img src={BONUS3_IMAGE} alt="Bono #3 - Calendario de Contenido" className="w-full max-w-sm mx-auto rounded-xl shadow-lg hover:scale-105 transition-transform duration-300" style={{
              width: '400px',
              height: '400px',
              objectFit: 'contain'
            }} data-id="element-343" />
            </a>
            <p className="text-gray-700 text-sm mt-4 max-w-md mx-auto" data-id="element-344">
              Listo para organizar tu semana de publicaciones sin estrés: qué
              publicar cada día con el método probado UGC para atraer clientas.
            </p>
          </div>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-345" />

        {/* TWO FUTURES */}
        <section className="py-10" data-id="element-346">
          <h2 className="text-2xl md:text-3xl font-black text-black text-center mb-8" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-347">
            Hay dos versiones de vos dentro de 30 días 👇🏻
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-348">
            <div className="bg-gray-100 border-2 border-gray-400 rounded-xl p-6" data-id="element-349">
              <p className="text-2xl text-center mb-3" data-id="element-350">😭</p>
              <p className="text-sm text-gray-700 leading-relaxed" data-id="element-351">
                Seguís enviando difusiones de Whatsapp que nadie responde.
                Seguís publicando fotos "catálogo" que el algoritmo ignora. Y lo
                peor de todo: seguís sin ventas y viendo cómo otras socias sí
                crecen cada mes... sin entender qué están haciendo diferente.
              </p>
            </div>
            <div className="bg-green-50 border-2 border-green-500 rounded-xl p-6" data-id="element-352">
              <p className="text-2xl text-center mb-3" data-id="element-353">😍</p>
              <p className="text-sm text-gray-700 leading-relaxed" data-id="element-354">
                Abrís Instagram por la mañana y tenés 7 mensajes nuevos de
                mujeres preguntando por los kits. Tenés un sistema de Contenido
                UGC que te genera ventas todas las semanas. Al fin tenes nuevas
                socias que llegaron solas. Tenés claridad sobre qué publicar,
                cómo estructurarlo y qué decir cuando alguien te escribe.
              </p>
            </div>
          </div>
        </section>

        {/* URGENCY & SCARCITY */}
        <UrgencyScarcity data-id="element-355" />

        {/* PRICING SECTION - PREMIUM */}
        <section className="py-12 pt-[0px] pb-[0px] mt-[20px] mb-[20px]" id="precio" data-id="element-356">
          <div className="relative overflow-hidden rounded-[36px] p-6 md:p-10 shadow-2xl" style={{
          background: 'linear-gradient(180deg, #14121C 0%, #221B2C 100%)',
          border: '1px solid rgba(255,255,255,0.08)'
        }} data-id="element-357">
            {/* Neon glow accents */}
            <div className="absolute -top-10 left-1/2 -translate-x-1/2 w-64 h-40 rounded-full blur-[80px] opacity-40 pointer-events-none" style={{
            background: '#85C3D7'
          }} data-id="element-358" />
            <div className="absolute bottom-0 right-0 w-52 h-52 rounded-full blur-[90px] opacity-30 pointer-events-none" style={{
            background: '#D7B2D8'
          }} data-id="element-359" />

            {/* Pill tag */}
            <div className="relative z-10 flex justify-center mb-6" data-id="element-360">
              <span className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-xs md:text-sm font-black tracking-[0.15em] uppercase text-white" style={{
              fontFamily: 'Montserrat, sans-serif',
              background: 'rgba(255,255,255,0.06)',
              border: '1px solid rgba(215,178,216,0.4)'
            }} data-id="element-361">
                <SparklesIcon className="w-4 h-4 text-[#D7B2D8]" data-id="element-362" />
                Valor por tiempo limitado
              </span>
            </div>

            {/* Subtitle */}
            <p className="relative z-10 text-center text-gray-300 text-base md:text-lg font-medium mb-3" data-id="element-363">
              ¡Este valor especial estará sólo por tiempo limitado!
            </p>

            {/* Neon headline */}
            <h2 className="relative z-10 text-center text-4xl md:text-5xl font-black mb-8 leading-none" style={{
            fontFamily: 'Montserrat, sans-serif',
            color: '#FFFFFF',
            textShadow: '0 0 12px rgba(133,195,215,0.9), 0 0 28px rgba(133,195,215,0.6), 0 0 48px rgba(133,195,215,0.4)'
          }} data-id="element-364">
              ACCEDÉ
              <br data-id="element-365" />
              AHORA
            </h2>

            {/* Product image on white card */}
            <div className="relative z-10 bg-white rounded-3xl p-6 md:p-8 shadow-xl" data-id="element-366">
              <img src={PRODUCT_IMAGE} alt="Fórmula UGC para Emprendedoras Nu Skin — todo lo que recibís" className="w-full max-w-sm mx-auto mb-6" data-id="element-367" />

              {/* Checklist */}
              <div className="space-y-4 text-left max-w-md mx-auto" data-id="element-368">
                {['Acceso Permanente', 'Soporte + Actualizaciones', '6 BONOS de regalo 🎁', 'Garantía de satisfacción'].map(item => <div key={item} className="flex items-center gap-3" data-id="element-369">
                    <span className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center" style={{
                  background: '#ECD7EB'
                }} data-id="element-370">
                      <CheckIcon className="w-4 h-4 text-[#B26FB4]" strokeWidth={3} data-id="element-371" />
                    </span>
                    <span className="text-black font-bold text-base" style={{
                  fontFamily: 'Montserrat, sans-serif'
                }} data-id="element-372">
                      {item}
                    </span>
                  </div>)}
              </div>

              {/* Premium included callout */}
              <div className="mt-8 max-w-md mx-auto" data-id="element-373">
                <div className="flex justify-center mb-[-14px] relative z-10" data-id="element-374">
                  <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full text-xs font-black uppercase tracking-wide text-white bg-[#85C3D7]" style={{
                  fontFamily: 'Montserrat, sans-serif'
                }} data-id="element-375">
                    <SparklesIcon className="w-3.5 h-3.5" data-id="element-376" />
                    Premium incluido
                  </span>
                </div>
                <div className="rounded-2xl border-2 border-[#85C3D7] bg-[#F2FAFC] p-5 pt-6 flex items-start gap-3" data-id="element-377">
                  <span className="flex-shrink-0 w-8 h-8 rounded-full bg-[#85C3D7] flex items-center justify-center" data-id="element-378">
                    <VideoIcon className="w-4 h-4 text-white" data-id="element-379" />
                  </span>
                  <p className="text-black font-bold text-base leading-snug" style={{
                  fontFamily: 'Montserrat, sans-serif'
                }} data-id="element-380">
                    Comunidad de Emprendedoras en Whatsapp✨✨
                  </p>
                </div>
              </div>

              {/* Price block */}
              <div className="mt-8 text-center" data-id="element-381">
                <p className="text-lg md:text-xl font-black text-[#E11D48] line-through tracking-wide mb-1" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-382">
                  ANTES $109.990 ARS
                </p>
                <p className="text-2xl md:text-3xl font-black text-black mb-2" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-383">
                  ¡SÓLO POR HOY! 😱
                </p>
                <p className="text-5xl md:text-6xl font-black mb-4 text-[#10B981]" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-384">
                  $49.990 ARS
                </p>

                {/* Recommended badge */}
                <div className="flex justify-center mb-4" data-id="element-385">
                  <span className="inline-flex items-center gap-2 px-5 py-2 rounded-full text-xs md:text-sm font-black uppercase tracking-wide text-[#FFFFFF] bg-[#10B981]" style={{
                  fontFamily: 'Montserrat, sans-serif'
                }} data-id="element-386">
                    100% Recomendado
                    <span className="text-[#FEF08A]" data-id="element-387">★★★★★</span>
                  </span>
                </div>

                <p className="text-gray-500 italic text-base mb-6" data-id="element-388">
                  - Hasta 3 cuotas -
                </p>

                {/* CTA */}
                <a href={PURCHASE_LINK} target="_blank" rel="noopener noreferrer" className="block w-full text-center text-white font-black py-5 px-6 rounded-2xl text-lg md:text-xl leading-tight transition-all duration-200 btn-pulse shadow-lg hover:shadow-xl hover:-translate-y-0.5 hover:bg-[#6FB4CA] bg-[#10B981]" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-389">
                  ACCESO AHORA · 7 DÍAS DE GARANTÍA ⭐
                </a>

                <p className="text-gray-400 text-xs uppercase tracking-wide font-bold mt-4" data-id="element-390">
                  Compra 100% segura y protegida
                </p>

                {/* Payment / security badges */}
                <div className="mt-6 flex justify-center" data-id="element-391">
                  <img src="https://cdn.magicpatterns.com/uploads/k4VntiK44CTwkfjN5W9XsF/pasted-image.jpg" alt="Mercado Pago · Site seguro SSL · Compra 100% segura" className="w-full max-w-xs object-contain" data-id="element-392" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ORDER BUMP - Below main offer */}

        {/* DIVIDER */}

        {/* GUARANTEE */}
        {/* PREMIUM GUARANTEE SECTION */}
        <section className="py-16 px-4 pt-[15px] pb-[15px]" data-id="element-393">
          <div className="max-w-xl mx-auto rounded-[40px] p-10 text-center relative overflow-hidden shadow-2xl" style={{
          background: 'linear-gradient(180deg, #0F111A 0%, #1A1D29 100%)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }} data-id="element-394">
            {/* Neon Glow behind icon */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-40 h-40 rounded-full blur-[60px] opacity-40 pointer-events-none" style={{
            background: '#85C3D7'
          }} data-id="element-395" />

            {/* Icon Container */}
            <div className="relative z-10 mb-8 flex justify-center" data-id="element-396">
              <div className="w-20 h-20 rounded-2xl flex items-center justify-center shadow-lg" style={{
              background: 'linear-gradient(135deg, #D7B2D8 0%, #B28DB3 100%)'
            }} data-id="element-397">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-398">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-399" />
                </svg>
              </div>
            </div>

            {/* Title */}
            <h2 className="md:text-3xl font-black mb-10 tracking-tight text-[#EAB308] text-[25px]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-400">
              GARANTÍA 7 DÍAS — <br data-id="element-401" />
              SIN PREGUNTAS
            </h2>

            {/* Content Box */}
            <div className="rounded-3xl p-8 mb-8 border relative z-10" style={{
            background: 'rgba(255, 255, 255, 0.03)',
            borderColor: 'rgba(255, 255, 255, 0.1)'
          }} data-id="element-402">
              <div className="space-y-6 text-gray-300 text-lg md:text-xl font-medium leading-relaxed" data-id="element-403">
                <p data-id="element-404">Accedes al programa. Lo aplicás en tus videos de Nu Skin.</p>
                <p data-id="element-405">Si en 7 días no es exactamente lo que esperabas:</p>

                <div className="text-3xl md:text-4xl font-black py-4 text-[#D7B2D8]" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-406">
                  devolución <br data-id="element-407" />
                  del 100%
                </div>

                <p className="text-white font-bold" data-id="element-408">
                  sin formularios, sin drama, sin explicaciones.
                </p>
              </div>
            </div>

            {/* Footer Stats */}
            <p className="text-gray-400 text-sm md:text-base font-medium relative z-10" data-id="element-409">
              Tasa de devoluciones:{' '}
              <span style={{
              color: '#D7B2D8'
            }} data-id="element-410">
                menos del 1%.
              </span>
            </p>
          </div>
        </section>

        {/* DIVIDER */}

        {/* COST OF INACTION */}
        <section className="py-14 px-1 pt-[25px] pb-[25px]" data-id="element-411">
          <div className="max-w-2xl mx-auto rounded-[36px] p-6 md:p-10 relative overflow-hidden shadow-2xl" style={{
          background: 'linear-gradient(180deg, #0F111A 0%, #1A1D29 100%)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }} data-id="element-412">
            {/* Glow accent */}
            <div className="absolute -top-10 right-0 w-52 h-52 rounded-full blur-[80px] opacity-30 pointer-events-none" style={{
            background: '#D7B2D8'
          }} data-id="element-413" />

            {/* Title */}
            <h2 className="relative z-10 text-3xl md:text-5xl font-black text-center leading-tight mb-5" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-414">
              <span className="text-white" data-id="element-415">🤔 ¿CUÁNTO CUESTA</span>
              <br data-id="element-416" />
              <span style={{
              color: '#D7B2D8'
            }} data-id="element-417">
                NO TENERLO?
              </span>
            </h2>

            <p className="relative z-10 text-gray-300 text-center text-sm md:text-base leading-relaxed max-w-md mx-auto mb-8" data-id="element-418">
              Cada semana que seguís sin un método probado, también tiene un
              precio. Esto es lo que realmente estás pagando al no tomar acción:
            </p>

            {/* Comparison table */}
            <div className="relative z-10 rounded-3xl overflow-hidden border" style={{
            background: 'rgba(255, 255, 255, 0.03)',
            borderColor: 'rgba(255, 255, 255, 0.1)'
          }} data-id="element-419">
              {/* Header row */}
              <div className="grid grid-cols-2" data-id="element-420">
                <div className="px-4 md:px-6 py-4 text-xs md:text-sm font-black uppercase tracking-wide text-white border-b border-r" style={{
                fontFamily: 'Montserrat, sans-serif',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-421">
                  Sin Fórmula UGC
                </div>
                <div className="px-4 md:px-6 py-4 text-xs md:text-sm font-black uppercase tracking-wide border-b" style={{
                fontFamily: 'Montserrat, sans-serif',
                color: '#D7B2D8',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-422">
                  Costo Real
                </div>
              </div>

              {/* Rows */}
              {[{
              problem: 'Publicás tus videos sin un método claro',
              cost: 'Horas perdidas grabando contenido que no vende'
            }, {
              problem: 'Buscás tips gratis y dispersos en redes',
              cost: 'Meses estancada, sin claridad ni resultados'
            }, {
              problem: 'Improvisás a prueba y error, sin estructura',
              cost: 'Contenido que las clientas ignoran'
            }, {
              problem: 'No sabés qué responder cuando te preguntan el precio',
              cost: 'Ventas que se enfrían y clientas que desaparecen'
            }, {
              problem: 'Seguís persiguiendo clientas una por una',
              cost: 'Te agotás y tus ventas no crecen'
            }, {
              problem: 'No lográs mostrar autoridad ni ser referente',
              cost: 'Nadie confía ni te compra a vos'
            }, {
              problem: 'Sin comunidad ni acompañamiento que te sostenga',
              cost: 'Te frustrás y abandonás tu negocio Nu Skin'
            }, {
              problem: 'Seguís en la misma rutina que no te llena',
              cost: 'Otro mes igual: sin ventas ni subir de rango'
            }].map((row, i, arr) => <div key={i} className={`grid grid-cols-2 ${i !== arr.length - 1 ? 'border-b' : ''}`} style={{
              borderColor: 'rgba(255,255,255,0.08)'
            }} data-id="element-423">
                  <div className="px-4 md:px-6 py-5 flex items-start gap-2 border-r" style={{
                borderColor: 'rgba(255,255,255,0.08)'
              }} data-id="element-424">
                    <XIcon className="w-4 h-4 flex-shrink-0 mt-0.5" strokeWidth={3} style={{
                  color: '#D7B2D8'
                }} data-id="element-425" />
                    <span className="text-white font-bold text-xs md:text-sm leading-snug" style={{
                  fontFamily: 'Montserrat, sans-serif'
                }} data-id="element-426">
                      {row.problem}
                    </span>
                  </div>
                  <div className="px-4 md:px-6 py-5 flex items-start gap-2" data-id="element-427">
                    <CornerDownRightIcon className="w-4 h-4 flex-shrink-0 mt-0.5" strokeWidth={3} style={{
                  color: '#D7B2D8'
                }} data-id="element-428" />
                    <span className="font-bold text-xs md:text-sm leading-snug" style={{
                  fontFamily: 'Montserrat, sans-serif',
                  color: '#D7B2D8'
                }} data-id="element-429">
                      {row.cost}
                    </span>
                  </div>
                </div>)}
            </div>

            {/* Closing line */}
            <p className="relative z-10 text-center text-white italic font-bold text-lg md:text-2xl leading-relaxed mt-9 max-w-lg mx-auto" style={{
            fontFamily: 'Georgia, serif'
          }} data-id="element-430">
              La pregunta no es cuánto cuesta el programa…{' '}
              <span style={{
              color: '#D7B2D8'
            }} data-id="element-431">
                es cuánto te cuesta seguir como estás.
              </span>
            </p>
          </div>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-432" />

        {/* FAQ */}
        <section className="py-12" data-id="element-433">
          <div className="text-center mb-10" data-id="element-434">
            <span className="inline-block text-xs md:text-sm font-bold px-4 py-2 rounded-full uppercase tracking-widest text-[#FFFFFF] bg-[#85C3D7] mb-5" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-435">
              ¿Tenés dudas?
            </span>
            <h2 className="text-4xl md:text-6xl font-black text-black leading-none uppercase" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-436">
              Preguntas
              <br data-id="element-437" />
              <span className="text-[#85C3D7]" data-id="element-438">Frecuentes</span>
            </h2>
            <p className="text-gray-500 text-sm md:text-base mt-4 max-w-md mx-auto" data-id="element-439">
              Tocá cada pregunta para ver la respuesta.
            </p>
          </div>

          <FaqAccordion data-id="element-440" />
        </section>

        {/* FINAL CTA */}
        <section className="py-10 text-center" data-id="element-441">
          <div className="bg-black text-white rounded-2xl p-8 mb-6" data-id="element-442">
            <h2 className="text-2xl md:text-3xl font-black mb-4" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-443">
              ¿Estás lista para que las clientas
              <br data-id="element-444" />
              <span className="text-yellow-300 bg-[#10B981]" data-id="element-445">
                te persigan a VOS?
              </span>
            </h2>
            <p className="text-gray-300 mb-6 text-base" data-id="element-446">
              Acceso inmediato · Garantía 7 días · Un solo pago
            </p>
            <a href={PURCHASE_LINK} target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-green-500 hover:bg-green-400 text-white font-black py-6 px-6 rounded-lg text-xl leading-tight transition-all duration-200 btn-pulse shadow-xl" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-447">
              👉 ¡SÍ, QUIERO ACCEDER AHORA!
              <br data-id="element-448" />
              <span className="text-base font-bold opacity-90" data-id="element-449">
                (Acceso inmediato)
              </span>
            </a>
            <p className="text-gray-400 text-sm mt-4" data-id="element-450">
              🔥 HOY: $19.990 ARS · Precio regular:{' '}
              <span className="line-through" data-id="element-451">$79.990 ARS</span>
            </p>
          </div>
        </section>

        {/* FOOTER */}
        <footer className="py-8 border-t border-gray-200 text-center" data-id="element-452">
          <p className="text-gray-500 text-xs leading-relaxed" data-id="element-453">
            © Fórmula UGC para Emprendedoras Nu Skin. Todos los derechos
            reservados.
            <br data-id="element-454" />
            <em data-id="element-455">
              Este producto es independiente y no está afiliado, patrocinado ni
              respaldado por Nu Skin Enterprises Inc.
            </em>
          </p>
        </footer>
      </div>

      {/* Social Proof Popup */}
      <SocialProofPopup data-id="element-456" />
    </div>;
}